export var CLOLBasicFilters = /*#__PURE__*/function (CLOLBasicFilters) {
  CLOLBasicFilters["editedOrCreatedBy"] = "editedOrCreatedBy";
  CLOLBasicFilters["lastModified"] = "lastModified";
  return CLOLBasicFilters;
}({});